<!--
 * @Author: hanmiao
 * @Date: 2024-03-29 16:38:33
 * @description:
-->
<template>
  <div class="applets-promotion__details">
    <div class="relative">
      <div class="pad-mar__title">
        <h3 class="title">页面基础信息</h3>
        <div class="form-wrapper">
          <el-form label-position="right" label-width="auto" :model="info">
            <el-form-item>
              <span slot="label">
                <i class="red">*</i>
                标题名称：
              </span>
              <div class="input">
                <el-input placeholder="请输入" clearable v-model="info.title" />
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="pad-mar__title">
        <h3 class="title">内容详情</h3>
        <div class="editor">
          <TinyMce ref="editor" :value.sync="msg" />
          <el-button size="120" class="d5" @click="openPicSpace" round>
            图片空间
          </el-button>
          <PictureSpace v-if="pictureSpace" :origin="pictureSpace" classification="other" :isCalc="false" />
        </div>
      </div>
      <p class="btn-wrapper">
        <el-button size="98" class="sub-color" @click="saveNoticeDetails">
          提交
        </el-button>
      </p>
      <el-drawer :visible.sync="drawer" :append-to-body="false" direction="ttb" size="100%" :with-header="false"
        :modal="false">
      </el-drawer>
    </div>
  </div>
</template>
<script>
import TinyMce from 'components/TinyMce/'
import PictureSpace from 'views/PictureSpace/pictureSpace'
import uploadImg from 'mixins/uploadImg/'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('promotionIntro')

export default {
  name: 'systemNoticDetails',
  mixins: [uploadImg],
  data() {
    this.keyMap = {
      noticle_list: {
        name: 'info',
        noticle_id: 'id',
        noticle_title: 'title',
        noticle_body: 'content',
        noticle_image: 'imgs',
        status: 'status',
      }
    }
    return {
      drawer: false,
      pictureSpace: false,
      info: {
        imgs: [],
        content: ''
      }
    }
  },
  components: {
    TinyMce,
    PictureSpace
  },
  watch: {
    $route: {
      handler(to) {
        this.pic = []
        const { id, mark } = to.query
        if (id) {
          this.info = this.utils._cloneDeep(this.getPromotionIntro(id))
          this.info.imgs.length > 0 &&
            this.utils._replaceRich(this.info, 'imgs', 'content')
        }
      },
      immediate: true
    }
  },
  provide() {
    return {
      picMerge: this._picMerge
    }
  },
  computed: {
    ...mapGetters(['getPromotionIntro']),
    msg: {
      get() {
        return this.info.content
      },
      set(val) {
        this.info.content = val
      }
    }
  },
  methods: {
    /**
     * 保存
     */
    saveNoticeDetails() {
      const newKeyMap = this.utils._reverseObj(this.keyMap)

      this.formData = new FormData()
      const obj = {
        info: this.utils._cloneDeep(this.info)
      }
      this.utils._modifyObjKey(obj, newKeyMap)
      this.formData.append('data', JSON.stringify(obj.noticle_list))
      this.pic.forEach((v, i) => {
        this.formData.append(
          `${v.field}_file_${Date.now()}_${i}`,
          v.blob,
          v.name
        )
      })
      this.api.saveNoticeFormData(this.formData).then(res => {
        this.$notify({
          type: 'success',
          message: '保存成功~！🙂'
        })
        this.$router.go(-1)
      })
    },
    /**
     * 内容详情图片blob保存
     * @param val
     * @param fileName
     * @param index
     * @param  blobUrl
     * @private
     */
    _goodsDetailsPicSave(val, fileName, index, blobUrl) {
      this.info.imgs.push({
        status: 'ready',
        name: fileName,
        url: blobUrl
      })
      this.pic.push({
        blob: val,
        url: blobUrl,
        name: fileName,
        field: 'promote'
      })
    },

    /**
* 保存的时候去除goodsDetailsPic不存在的数据
* @private
*/
    _filterGoodsDetailsPic() {
      const { content, imgs } = this.info
      const getAllSrc = str => {
        return str.match(/src=\S+\b/gi).map(v => {
          return v.replace(/src="/, '')
        })
      }
      const promote = content && content.includes('img') && getAllSrc(content)
      const filterSrc = arr => {
        return arr.filter(v => {
          return promote && promote.includes(v.url)
        })
      }
      this.pic = filterSrc(this.pic)
      this.info.imgs = filterSrc(imgs)
    },

    /**
     * 打开图片空间
     */
    openPicSpace() {
      this.pictureSpace = !this.pictureSpace
    },
    /**
     * 从图片空间合并图片
     * @param obj
     */
    _picMerge(obj) {
      this.msg += `<p><img src="${obj.url}" /></p>`
    },
  }
}
</script>
<style lang="scss">
.applets-promotion__details {
  .pagination {
    bottom: 0 !important;
  }

  .input {
    width: 25rem;
  }

  .btn-wrapper {
    text-align: center;
  }

  .d5 {
    margin-top: 2rem;
  }

  .editor {
    padding-right: 8.5rem;
  }

  .relative {
    .table-wrapper {
      min-height: initial !important;
    }

    .el-drawer {
      overflow: auto;
    }

    .el-drawer__header {
      margin: 0;
    }

    >.el-dialog__wrapper {
      bottom: 0;
      height: 35%;
      box-shadow: 0 8px 10px -5px rgba(0, 0, 0, 0.2),
        0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12);
    }
  }

  .ad-uploader .el-upload {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    width: 25rem;
    height: 15rem;
    background-color: #f7f7f7;
    vertical-align: bottom;
    margin-right: 1.3rem;
  }

  .preview-img {
    width: 100%;
    object-fit: contain;
  }

  .icon-tupian {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2.8rem;
    height: 2.8rem;
    background-color: colors('d3');
    border-radius: 50%;
    margin: 0 auto;

    &:before {
      color: #fff;
      font-size: 1.1rem;
    }
  }

  .opearting {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 1.9rem;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;

    .change {
      width: 2.5rem;
      height: 1.3rem;
      line-height: 1.3rem;
      background-color: colors('bg-sub');
      border-radius: 0.6rem;
      display: inline-block;
      color: #fff;
      margin: 0 1.3rem 0 1.1rem;
    }

    .icon-shanchu {
      font-size: 1.1rem;
      color: #fff;
    }
  }

  .tips {
    color: colors('a4');
  }
}
</style>
